import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEnvelopeRegularReportIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18.9 22.3q1 .1 1.1 1v3.8q-.1 1-1.1 1.1H18q-1-.1-1.1-1v-3.8q.1-1 1.1-1.1zm4.5-4.6q1 .2 1.1 1.2V27q-.1 1-1.1 1.1h-.8q-1-.1-1.1-1v-8.3q.1-1 1.1-1.1zm4.5 1.6h.5l.1.1.1.1.1.1v.1h.1l.2.7V27q-.1 1-1.1 1.1H27q-1-.1-1.1-1v-6.8q0-.6.5-1h.2v-.1H28M25.7 6.4a3 3 0 0 1 3.1 3v8l-1-.1h-1.4v-4.5l-3.9 3q-2.1.1-2.9 2.1l-1 .8a4.4 4.4 0 0 1-5.3 0l-7.7-5.9v9.6q.1.7.8.8H15v2.4H6.4a3 3 0 0 1-3.2-3.2V9.5a3 3 0 0 1 3-3.1zM6.3 8.8a.7.7 0 0 0-.4 1.2l8.9 6.8a2 2 0 0 0 2.4 0l9-6.8.2-.5q0-.7-.7-.7z" })
});
export default SvgEnvelopeRegularReportIcon;
